import React, {useEffect, useRef, useState} from 'react'
import PaperComponent from "../../components/MuiDraggableDialog";
import {
    LinearProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import MDButton from "../../components/MDButton";
import {useTranslation} from "react-i18next";
import {ASNInfo} from "../../actions/inbounds/inboundsAction";
import {useDispatch, useSelector} from "react-redux";
import {Logout, onErrorAlert} from "../../actions";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import Barcode from "react-barcode";
import {useReactToPrint} from "react-to-print";
import MDTypography from "../../components/MDTypography";
export default function PrintPanel({currentRow,isOpen,setIsOpen}){
    const {t} = useTranslation()
    const [loading,setLoading] = useState(false)
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [products,setProducts] = useState([])
    const [basicInfo,setBasicInfo] = useState({})
    const labelComponentRef = useRef();
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)

    const handlePrint = useReactToPrint({
        documentTitle:`Inbound_${moment().format('YYYYMMDD')}.pdf`,
        content: () => labelComponentRef.current,
        onAfterPrint: () => {
            setIsOpen(false)
        },
        pageStyle: `@media print {
                  header, footer, aside, form, … {
                    display: none;
                  }
                  article {
                    width:100%!important;
                    height:100%!important;
                    padding:0% !important;
                    margin:0!important;
                  }
                }
                @page {
                  margin: 0.5cm;
                }`
    });

    const onError = (msg,code) => {
        dispatch(onErrorAlert(t(msg)))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }
    const onInfoSuccess = (currentData) => {

        setProducts([...currentData?.details])
        setBasicInfo(currentData?.warehousing)
        setLoading(false)
    }
    const handleCloseModal = () => {
        setIsOpen(false)

    }

    useEffect(() => {

        if(!isOpen){
            handleCloseModal()

        } else {
            const axiosPost= async () => {
                let formData = {}
                formData.ownerId = currentRow?.ownerId
                formData.applyAsnNo = currentRow?.applyAsnNo
                formData.userName = currentRow?.ownerName
                setLoading(true)
                await dispatch(ASNInfo(formData, onInfoSuccess,onError))
            }
            axiosPost().then()
        }


    }, [isOpen]);


    return(<React.Fragment>
        <Dialog
            open={isOpen}
            onClose={()=>{}}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={'paper'}
            fullWidth={true}
            maxWidth={'xl'}
        >


                <DialogTitle style={{cursor: 'move', display: 'flex', justifyContent: 'space-between'}}
                             id="draggable-dialog-title">
                    {`${t('Print')} ${basicInfo?.applyAsnNo}`}
                    <IconButton size="large" onClick={() => setIsOpen(false)}>
                        <Icon>cancel</Icon>
                    </IconButton>
                </DialogTitle>
                <DialogContent >
                    <DialogContentText>
                        <Paper elevation={0} sx={{width:420,height:594,background:'white'}} >
                            {loading ?
                                <Grid sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <LinearProgress color='info'/>
                                </Grid>
                                : <article ref={labelComponentRef} className={'print-container'} >
                                    <Grid container width={'100%'} p={2} flexDirection={'column'} >
                                        <Grid item container flexDirection={'row'} justifyContent={'flex-start'} alignItems={'flex-end'}>
                                            <Grid item>
                                                <h3>FBD-PREP</h3>
                                            </Grid>

                                        </Grid>
                                        <Grid item height={10} sx={{fontSize:'xx-large',border:'7px solid black'}} >
                                        </Grid>
                                        <Grid item container flexDirection={'row'} mt={1} mb={1} justifyContent={'space-between'}>
                                            <Grid item xs={6}>
                                                <h6 style={{lineHeight: 'normal'}}>{t('InboundPage.Ship from')}</h6>
                                                <h6 style={{lineHeight: 'normal'}}>{basicInfo?.customerName}</h6>
                                                {/*<h6 style={{lineHeight:'normal'}}>{`${basicInfo?.customerAddress}`}</h6>*/}
                                                <h6 style={{wordWrap: 'break-word', lineHeight: 'normal'}}>
                                                    {basicInfo?.customerAddress1}
                                                </h6>
                                                <h6 style={{lineHeight: 'normal'}}>{`${basicInfo?.customerCity} ${basicInfo?.customerProvince} ${basicInfo?.customerCountry} ${basicInfo?.customerZipcode}`}</h6>
                                            </Grid>
                                            <Grid item xs={6}>
                                            <h6 style={{lineHeight:'normal'}}>{t('InboundPage.Ship to')}:</h6>
                                                <h6 style={{lineHeight:'normal',wordBreak: 'break-all'}}> {basicInfo?.warehouseAddress} </h6>
                                            </Grid>
                                        </Grid>
                                        <Grid item sx={{borderBottom:'14px solid black'}}>
                                            <p style={{textAlign:'end',fontSize:'x-small'}}>{`${t('InboundPage.Time Created')}: ${moment().locale(languageSelect === 'zh'?'zh-cn':languageSelect).format('MMMM Do YYYY, h:mm a')}`}</p>
                                        </Grid>
                                        <Grid mt={2} mb={2} item xs={12} sx={{
                                            height: '20%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            {basicInfo?.omsExAsnNo && <Barcode textPosition={'bottom'} width={1.5} height={30} value={basicInfo?.omsExAsnNo} format="CODE128"/>}
                                        </Grid>
                                        <Grid item container>
                                            <Grid item xs={6}>
                                                <h6>{`${t('Owner ID')}: ${basicInfo?.ownerId}`}</h6>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <h6>{`${t('Owner Name')}: ${basicInfo?.ownerName}`}</h6>
                                            </Grid>
                                        </Grid>
                                        <Grid item container sx={{
                                            border:'1px solid black',
                                            textAlign:'center'
                                        }}
                                        >
                                            <Grid item container>
                                                <Grid item xs={1} sx={{
                                                    border:'1px solid black'
                                                }}>
                                                    <h6>
                                                        {t('Line')}
                                                    </h6>
                                                </Grid>
                                                <Grid item xs={3} sx={{
                                                    border:'1px solid black'
                                                }}>
                                                    <h6>
                                                        {t('SKU')}
                                                    </h6>

                                                </Grid>
                                                <Grid item xs={6} sx={{
                                                    border:'1px solid black'
                                                }}>
                                                    <h6>
                                                        {t('Product Name')}
                                                    </h6>

                                                </Grid>

                                                <Grid item xs={1} sx={{
                                                    border:'1px solid black'
                                                }}>
                                                    <h6>
                                                        {t('Qty')}
                                                    </h6>
                                                </Grid>
                                                <Grid item xs={1} sx={{
                                                    border:'1px solid black'
                                                }}>
                                                    <h6>
                                                        {t('Unit')}
                                                    </h6>
                                                </Grid>
                                            </Grid>
                                            {
                                                products?.map((v,i)=>
                                                    <Grid item container >
                                                        <Grid item xs={1} sx={{
                                                            border:'1px solid black'
                                                        }}>
                                                           <h6>
                                                               {(i+1)}
                                                           </h6>
                                                        </Grid>
                                                        <Grid item xs={3} sx={{
                                                            border:'1px solid black',
                                                            wordBreak: 'break-all'
                                                        }}>
                                                            <h6>
                                                                {v?.sku}
                                                            </h6>

                                                        </Grid>
                                                        <Grid item xs={6} sx={{
                                                            border:'1px solid black',
                                                            wordBreak: 'break-all'
                                                        }}>
                                                            <h6>
                                                                {v?.productName}</h6>

                                                        </Grid>

                                                        <Grid item xs={1} sx={{
                                                            border:'1px solid black'
                                                        }}>
                                                            <h6>
                                                                {v?.unitQty}
                                                            </h6>
                                                        </Grid>
                                                        <Grid item xs={1} sx={{
                                                            border:'1px solid black'
                                                        }}>
                                                            <h6>{v?.unit}</h6>
                                                        </Grid>
                                                    </Grid>
                                                )
                                            }
                                        </Grid>

                                    </Grid>
                                  </article>}
                        </Paper>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={'outlined'}  color = 'primary' onClick={() => setIsOpen(false)}>
                        {t(`Cancel`)}
                    </MDButton>

                        <MDButton color = 'primary' onClick={handlePrint}>
                            {t('Print')}
                        </MDButton>

                </DialogActions>

        </Dialog>
    </React.Fragment>)
}

